import React, {useEffect, useState} from 'react'
import ContainerBackgroundWrapper from '../components/Backgrounds'
import star from '../assets/images/star.svg'
import {
  BloqueLista,
  BloqueTitulo,
  ItemClasificado,
  ItemRank
} from '../styledComponents/TorneoStyled'
import useFetch from "../hooks/useFetch";
import {Apis} from "../util/Apis";
import { maskName } from '../util/privacy'
import defaultLogo from '../assets/images/logo.png'
import { LogoImage } from '../components/LogoCenter'
import Text, { TextGold } from '../styledComponents/TextStyled'
import NoSorteos from '../components/NoSorteos'
import {getCurrencyConfig} from "../components/services";
import CountdownTimer from '../components/CountdownTimer'
import { parseDateTime } from '../util/dateUtils'

const TorneoViewRankCore = ({sala, torneo}) => {

  const couponTypeId = torneo.couponTypeId
  const tournamentDate = parseDateTime(torneo.fechaHora)
  const fechaDelTorneo = tournamentDate ? tournamentDate.toISO() : null

  const countDownDate = tournamentDate ? tournamentDate.toMillis() : null
  const now = new Date().getTime()
  const distance = typeof countDownDate === 'number' ? countDownDate - now : null

  const [estado, setEstado] = useState(false);

  const {
    data,
    error,
    fetchData
  } = useFetch(Apis.PC + '/coupon/group-by-customer?couponTypeId=' + couponTypeId, []);

  useEffect(() => {
    if (distance === null) {
      return
    }

    const timeout = setTimeout(() => {
      setEstado(true);
      //TODO, debemos detener el refresco automatico, cuando el sorteo acabo
    }, Math.max(distance, 0));
    return () => clearTimeout(timeout);
  }, [distance])

  useEffect(() => {
    const interval = setInterval(() => {
      fetchData()
    }, 5000);
    return () => clearInterval(interval);
  }, [fetchData])

  let logoImg = sala.logo
  if (logoImg === undefined) {
    logoImg = defaultLogo
  }

  const currencyConfig = getCurrencyConfig()

  return (
    <ContainerBackgroundWrapper showBackgroundCard={false}>
      <BloqueTitulo style={{height:'calc(20vh - 1rem)'}}>
        <LogoImage src={logoImg} alt='logowhite' />
        <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:'8px'}}>
          <TextGold >{torneo.couponTypeName}</TextGold>
          <Text>CLASIFICACIÓN</Text>

          {!estado && fechaDelTorneo &&
            <CountdownTimer targetDate={fechaDelTorneo} />
          }
        </div>
        <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:'8px'}}>
          <Text textStyle='small'>PREMIO</Text>
          <TextGold textStyle='small'>{currencyConfig.symbol} {torneo.amount}</TextGold>
        </div>
      </BloqueTitulo>

      <BloqueLista style={{height:'calc(80vh - 1rem)'}}>
        <div style={{display:'grid', gridTemplateColumns:'80px 1fr 100px',marginTop:'0.5rem', fontSize:'0.9rem',width:'100%'}}>
          <div style={{paddingLeft:'20px'}}>Rank</div>
          <div style={{textAlign:'left'}}>Jugador</div>
          <div style={{paddingRight:'20px'}}>Puntos</div>
        </div>

        {!data?.length > 0 ?
          <NoSorteos>
            <Text textStyle='small'>{error ? 'No se pudo cargar la clasificación' : 'aun no hay jugadores participantes...'}</Text>
          </NoSorteos>
          :
          <div style={{overflowY:'auto',width:'100%'}} className='custom-scroll'>
            {data.slice(0, 100).map(item =>
              <ItemClasificado key={item.rank} $cantidad={torneo.winnerQuantity + 1} style={{margin:'1rem 0.5rem',gridTemplateColumns: '80px 1fr 100px'}}>
                <ItemRank>
                  <img src={star} alt='star'/>
                  <span>{item.rank}</span>
                </ItemRank>
                <Text style={{textAlign:'left',fontSize:'20px'}}>{maskName(item.firstName, item.lastName1, true)}</Text>
                <Text style={{fontSize:'20px'}}>{item.total}</Text>
              </ItemClasificado>
            )
            }
          </div>
        }
      </BloqueLista>
    </ContainerBackgroundWrapper>
  );
};

export default TorneoViewRankCore;
